//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 27/12/2023
// Version       : 1
// Description   : Tabla para Agregar, Editar y Deshabilitar Sectores
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   : 19/06/2025
// Change by     : Guillermo Sedran
// Change description: Refactorización + cambio de estilo
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import Navbar from "../Navbar";
import React, { useEffect, useState, useMemo } from "react";
import { UrlApi } from "../../services/apirest";
import { MaterialReactTable } from "material-react-table";

// TABLA EN ESPAÑOL
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Box,
  Typography,
  Stack,
  Grid,
  Tooltip,
  TextField,
} from "@mui/material";
import { lighten } from "@mui/material/styles";

import { createTheme, ThemeProvider, useTheme } from "@mui/material";

// LOG EVENTOS
import { logEventos } from "../../services/services";

//Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import BlockIcon from "@mui/icons-material/Block";

// ICONOS
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import EditIcon from "@mui/icons-material/Edit";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Sectores() {
  const [sectores, setSectores] = useState({});
  const [datosFormulario, setDatosFormulario] = useState({
    nombre_sector: "",
    estado: 1,
  });
  const [update, setUpdate] = useState(false);
  const [tabla, setTabla] = useState(true);

  const obtenerSectores = () => {
    fetch(UrlApi + "/sectores/tabla")
      .then((data) => data.json())
      .then((data) => {
        setSectores(data); // Datos de la tabla
      });
  };

  useEffect(() => {
    obtenerSectores();
  }, [tabla]);

  // FUNCION QUE SE EJECUTA CADA VEZ QUE HAY UN CAMBIO EN LA BASE DE DATOS
  // SIRVE PARA QUE LA TABLA MOSTRADA SE ACTUALICE EN TIEMPO REAL
  useEffect(() => {
    if (update) obtenerSectores();
  }, [update]);

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  //*************************************************************************************************************************************/

  const columns = useMemo(
    () => [
      { header: "ID", accessorKey: "id_sector", size: 100 },
      { header: "Nombre", accessorKey: "nombre_sector", size: 100 },
    ],
    []
  );

  //*************************************************************************************************************************************/

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setUpdate(false);
    setOpenEditar(false);
    setOpenCrear(false);
    setOpenDialogOnOff(false);
  };

  //*************************************************************************************************************************************/

  // DIALOG PARA CREAR LOS DATOS
  const [openCrear, setOpenCrear] = React.useState(false);

  const handleClickOpenCrear = () => {
    setOpenCrear(true);
    // AL ABRIR EL DIALOG VACIO EL TEXTFIELD
    datosFormulario.nombre_sector = "";
  };

  const handleCloseCrear = () => {
    setOpenCrear(false);
    // RECARGAR TABLA
    obtenerSectores();
  };

  //*************************************************************************************************************************************/

  // DIALOG PARA EDITAR LOS DATOS
  const [openEditar, setOpenEditar] = React.useState(false);

  // USANDO ROW TOMO LOS DATOS DE ESA FILA
  const handleClickOpenEditar = (row) => {
    setOpenEditar(true);
    setDatosFormulario(row);
  };

  const handleCloseEditar = (row) => {
    setOpenEditar(false);
  };

  //**********************************************************************************************/

  // DIALOG PARA ACTIVAR/DESACTIVAR LA RELACIÓN
  const [openDialogOnOff, setOpenDialogOnOff] = React.useState(false);

  const handleCloseDialogOnOff = () => {
    setOpenDialogOnOff(!openDialogOnOff);
  };

  const dialogActivar = (row) => {
    setDatosFormulario(row);
    setOpenDialogOnOff(true);
  };

  //*************************************************************************************************************************************/

  const guardarCrear = async (e) => {
    logEventos(
      "Guardar sector",
      "Sectores",
      "Guardar sector",
      localStorage.getItem("user")
    );

    e.preventDefault();
    await fetch(UrlApi + "/sectores", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nombre_sector: datosFormulario.nombre_sector,
        estado: 1,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          setUpdate(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El sector se guardó exitosamente !");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el sector");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  //*************************************************************************************************************************************/

  const guardarEditar = async (e) => {
    e.preventDefault();
    await fetch(UrlApi + "/sectores/" + datosFormulario.id_sector, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nombre_sector: datosFormulario.nombre_sector,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          setUpdate(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El sector se guardó exitosamente !");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el sector");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  //*************************************************************************************************************************************/

  const almacenar = (e) => {
    setDatosFormulario({
      ...datosFormulario,
      [e.target.name]: e.target.value,
    });
  };

  //*************************************************************************************************************************************/

  // FUNCIONES PARA GUARDAR:
  // ACTIVAR TIPO DE ENVASE
  const guardarActivo = async (e) => {
    e.preventDefault();
    await fetch(UrlApi + "/sectores/" + datosFormulario.id_sector, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        estado: 1,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El sector se guardó exitosamente !");
          setUpdate(true);
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el sector");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  // DESACTIVAR TIPO DE ENVASE
  const guardarInactivo = async (e) => {
    e.preventDefault();
    await fetch(UrlApi + "/sectores/" + datosFormulario.id_sector, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        estado: 0,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El sector se guardó exitosamente !");
          setUpdate(true);
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el sector");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  //*************************************************************************************************************************************/
  // ESTILO PARA LA TABLA
  const globalTheme = useTheme();

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { backgroundColor: "#ffffff" },
    variant: "outlined",
    size: "small",
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  useEffect(() => {
  logEventos(
  "acceso al menú Sectores", 
  "Tablas Referencias", 
  "Sectores", 
  localStorage.getItem("user"));
}, []);


  return (
    <>
      <Navbar />
      <Container maxWidth="xl" mt={1}>
        <Box mt={2} mb={4}>
          <ThemeProvider theme={tableTheme}>
            <MaterialReactTable
              enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
              enableGrouping // para permitir agrupar x estado x ej
              layoutMode="grid"
              muiTableBodyCellProps={({ row }) => ({
                align: "left", //el contenido de la tabla
                sx: {
                  backgroundColor:
                    row.original.estado === 1 ? "#b3e6b3" : "#efc3c3",
                  color: "black",
                  borderColor: "black",
                  //COLOR AL PASAR EL MOUSE POR ENCIMA
                  "&:hover": {
                    backgroundColor:
                      row.original.estado === 1
                        ? lighten("#b3e6b3", 0.4)
                        : lighten("#efc3c3", 0.4),
                  },
                  "& .MuiTableCell-root:first-child": {
                    border: "none",
                  },
                },
              })}
              muiTableHeadCellProps={tableHeadCellProps}
              enableColumnActions={true} //los puntitos de al lado de los titulos (acciones) -> hay que activarlo para agrupar x estado x ej
              enableColumnFilters={false} //desactiva filtros x columna
              enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
              enableDensityToggle={false}
              enableColumnDragging={false} //para arrastrar columnas
              enableEditing={false}
              enableFullScreenToggle={false}
              enablePagination={true}
              localization={MRT_Localization_ES} //idioma
              initialState={initialState}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              columns={columns}
              data={sectores}
              enableStickyFooter
              positionActionsColumn="last" // posicion de la columna de acciones al final
              enableRowActions
              renderRowActions={({ row }) => (
                <>
                  <Tooltip
                    arrow
                    placement="left"
                    disableInteractive
                    title="Editar Sector"
                  >
                    <Button
                      backgroundColor="#ffffff"
                      size="small"
                      onClick={() => handleClickOpenEditar(row.original)}
                    >
                      <EditIcon />
                    </Button>
                  </Tooltip>

                  <Tooltip
                    arrow
                    placement="left"
                    disableInteractive
                    title={
                      row.original.estado === 1
                        ? "Bloquear Sector"
                        : "Activar Sector"
                    }
                  >
                    <IconButton onClick={() => dialogActivar(row.original)}>
                      <BlockIcon
                        sx={{
                          color:
                            row.original.estado === 1 ? "red" : "lightgreen",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </>
              )}
              renderTopToolbarCustomActions={() => (
                <>
                  <Typography variant="poster" fontSize={26}>
                    Sectores
                  </Typography>

                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddBoxTwoToneIcon />}
                    onClick={handleClickOpenCrear}
                    size="small"
                  >
                    Agregar Sector
                  </Button>
                </>
              )}
            />
          </ThemeProvider>
        </Box>
      </Container>

      {/* CREAR ITEM */}
      <Dialog
        open={openCrear}
        onClose={handleCloseCrear}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        {" "}
        <Box
          sx={{
            border: "2px solid #2B76A6",
            borderRadius: 1,
          }}
        >
          <DialogTitle
            sx={{
              p: 0,
              mt: 0,
              mb: 1,
              display: "flex",
              justifyContent: "flex-start", // alineado a la izquierda
              alignItems: "flex-start",
            }}
          >
            <Typography
              variant="h6"
              color="white"
              sx={{
                backgroundColor: "#2B76A6",
                borderBottomRightRadius: "12px", // solo esquina inferior derecha
                padding: "8px 18px",
              }}
            >
              Agregar Sector
            </Typography>
          </DialogTitle>
          <form onSubmit={guardarCrear}>
            <DialogContent>
              <Grid container mb={1}>
                <Grid item xs={12}>
                  <TextField
                    label="Nombre"
                    name="nombre_sector"
                    size="small"
                    placeholder="..."
                    focused
                    required
                    fullWidth
                    id="nombre_sector"
                    value={datosFormulario.nombre_sector}
                    onChange={almacenar}
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <Stack direction="row" justifyContent="center" spacing={2} mb={3}>
              <Grid container justifyContent="center">
                <Grid item xs={8}>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCloseCrear}
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button fullWidth variant="contained" type="submit">
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </form>{" "}
        </Box>
      </Dialog>

      {/* EDITAR ITEM */}
      <Dialog
        open={openEditar}
        onClose={handleCloseEditar}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <Box
          style={{
            borderWidth: 2,
            borderStyle: "solid",
            border: "2px solid #2B76A6",
          }}
        >
          <DialogTitle
            sx={{
              p: 0,
              mt: 0,
              mb: 1,
              display: "flex",
              justifyContent: "flex-start", // alineado a la izquierda
              alignItems: "flex-start",
            }}
          >
            <Typography
              variant="h6"
              color="white"
              sx={{
                backgroundColor: "#2B76A6",
                borderBottomRightRadius: "12px", // solo esquina inferior derecha
                padding: "8px 18px",
              }}
            >
              Editar Sector
            </Typography>
          </DialogTitle>

          <form onSubmit={guardarEditar}>
            <DialogContent>
              <Grid container mb={1}>
                <Grid item xs={12}>
                  <TextField
                    label="Nombre"
                    name="nombre_sector"
                    size="small"
                    placeholder="..."
                    focused
                    required
                    fullWidth
                    id="nombre_sector"
                    value={datosFormulario.nombre_sector}
                    onChange={almacenar}
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <Stack direction="row" justifyContent="center" mb={3}>
              <Grid container justifyContent="center">
                <Grid item xs={8}>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCloseEditar}
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button fullWidth variant="contained" type="submit">
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </form>
        </Box>
      </Dialog>

      {/* DIALOG PARA BLOQUEAR/DESBLOQUEAR LA RELACIÓN */}
      <Dialog open={openDialogOnOff} onClose={handleCloseDialogOnOff}>
        <Box
          style={{
            borderWidth: 2,
            borderStyle: "solid",
            border: "2px solid #2B76A6",
          }}
        >
          <DialogTitle sx={{ padding: 0, marginBottom: 2 }}>
            <Box
              sx={{
                backgroundColor: "#2B76A6",
                width: "100%",
                padding: "8px 0",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                {" "}
                <b>
                  {datosFormulario.estado === 1 ? "BLOQUEAR" : "DESBLOQUEAR"}{" "}
                  SECTOR
                </b>
              </Typography>
            </Box>
          </DialogTitle>

          <DialogContent>
            <DialogContentText
              textAlign={"center"}
              style={{ marginBottom: "30px" }}
            >
              <Grid item textAlign={"center"}>
                <br />
                {datosFormulario.nombre_sector}
              </Grid>
            </DialogContentText>
            <DialogContentText
              textAlign={"center"}
              style={{ marginBottom: "-10px", fontWeight: "bold" }}
            >
              {"¿Confirma que quiere " +
                (datosFormulario.estado === 1 ? "bloquear" : "desbloquear") +
                " este sector?"}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                sx={{
                  backgroundColor: "#d32f2f",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "#b71c1c", // Un rojo más oscuro en hover
                  },
                  "&:disabled": {
                    // Estilo para el botón en estado deshabilitado
                    backgroundColor: "rgba(0, 0, 0, 0.12)", // Color gris estándar de Material-UI
                    color: "rgba(0, 0, 0, 0.26)", // Texto gris estándar
                  },
                }}
                variant="contained"
                onClick={handleCloseDialogOnOff}
              >
                Volver
              </Button>
              {datosFormulario.estado === 1 ? (
                <Button
                  sx={{
                    color: "#ffffff",
                    "&:disabled": {
                      // Estilo para el botón en estado deshabilitado
                      backgroundColor: "rgba(0, 0, 0, 0.12)", // Color gris estándar
                      color: "rgba(0, 0, 0, 0.26)", // Texto gris estándar
                    },
                  }}
                  onClick={guardarInactivo}
                  variant="contained"
                >
                  Bloquear
                </Button>
              ) : (
                <Button
                  sx={{
                    color: "#ffffff",
                    "&:disabled": {
                      // Estilo para el botón en estado deshabilitado
                      backgroundColor: "rgba(0, 0, 0, 0.12)", // Color gris estándar
                      color: "rgba(0, 0, 0, 0.26)", // Texto gris estándar
                    },
                  }}
                  onClick={guardarActivo}
                  variant="contained"
                >
                  Desbloquear
                </Button>
              )}
            </Box>
          </DialogActions>
        </Box>
      </Dialog>

      {/* SNACKBAR QUE SE MOSTRARA AL GUARDAR LOS CAMBIOS */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default Sectores;
